import { Maybe } from '../generated/graphql';

export function getValueOrDefault<T>(value: Maybe<T>, defaultValue: T): T {
    return value !== null ? value : defaultValue;
}
